import PropTypes from 'prop-types';
import React from 'react';
import * as StringHelper from "../../helpers/stringHelper";

const propTypes = {
    name: PropTypes.string
};

export const LocationName = (props) => {

    if (!props.name) {
        return null;
    }
    const name = StringHelper.toTitleCase(props.name);

    return (
        <React.Fragment>
            <div className={props.className}>
                {name}
            </div>
        </React.Fragment>
    );
};

LocationName.propTypes = propTypes;

export default LocationName;
